export const removeAllCharactersExceptNumbersAndDecimals = (value: string) =>
  value
    .replace(/^0+(?!\.|$)/, '')
    .replace(/[^0-9.-]+/g, '')
    .replace(/-+/g, '-')
    .replace(/-$/, '');
